var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isVisible && !_vm.deactivated ? _c('div', {
    staticClass: "magnifier",
    style: _vm.style
  }, [_c('div', {
    staticClass: "magnifier-target"
  })]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }